import { HomeLightningBoltOutlineIcon } from './HomeLightningBoltOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 12538408-E644-4222-84BF-9A64670E9187
 * name home-lightning-bolt-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lightning-bolt-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseFlashOutlineIcon = HomeLightningBoltOutlineIcon;
export default HouseFlashOutlineIcon